<template>
  <section class="creditWalletCards">
    <CreditCardCarousel />
    <WalletCreditCarousel />
  </section>
</template>

<script setup>
import { useWalletStore } from '@/stores/useWalletStore';
import CreditCardCarousel from './CreditCardCarousel';
import WalletCreditCarousel from './WalletCreditCarousel';

const walletStore = useWalletStore();
onMounted(async () => {
  await walletStore.fetchCreditCards();
});
</script>

<style lang="scss" scoped>
.creditWalletCards {
  ::v-deep(.card-logo) {
    width: rem-calc(90px);
    height: auto;
  }

  ::v-deep(.logo-container) {
    align-self: center;
  }

  ::v-deep(.default-card) {
    font-size: rem-calc(12px);
    line-height: rem-calc(16px);
    color: $green;
    display: inline-block;
    vertical-align: top;
    margin: rem-calc(5px);
  }

  ::v-deep(.wallet-icon) {
    margin-bottom: rem-calc(5px);
    display: inline-block;
  }

  ::v-deep(.card-text p) {
    font-size: rem-calc(12px);
    line-height: rem-calc(16px);
    margin-bottom: 0;
  }

  ::v-deep(.card-text .mgn-btm) {
    margin-bottom: rem-calc(10px);
  }
  ::v-deep(.card-text .mgn-top) {
    margin-top: rem-calc(10px);
  }

  ::v-deep(.card-links .legal) {
    display: inline-block;
    line-height: rem-calc(16px);
    margin-left: rem-calc(5px);
    margin-bottom: rem-calc(16px);
  }
}
</style>
